module.exports = __webpack_public_path__ + "static/media/sbay-app-logo.f1eadfbb.png";